(function () {
  'use strict';

  // Find this script's own tag reliably (works with defer + shopify:section:load re-injection)
  const scriptTag = document.querySelector(
    'script[src*="shop-the-look-quick-view"]'
  );

  const rawSectionId = scriptTag
    ? scriptTag.dataset.sectionId
    : null;

  const sectionId = rawSectionId
    ? 'shop-the-look-hotspot-' + rawSectionId
    : null;

  function initSTLQuickView() {

    if (!sectionId) return;

    const section = document.getElementById(sectionId);

    if (!section) return;

    if (section.dataset.quickViewInitialized === 'true') {
      return;
    }

    section.dataset.quickViewInitialized = 'true';

    const quickViewButtons = section.querySelectorAll(
      '[data-quick-view]'
    );

    if (!quickViewButtons.length) return;

    const quickViewDrawer = document.querySelector(
      '#quick-view-drawer'
    );

    if (!quickViewDrawer) {
      console.warn(
        'Shop The Look: #quick-view-drawer not found.'
      );
      return;
    }


    const quickViewInner =
      quickViewDrawer.querySelector(
        '.quick-view-drawer_inner'
      );


    if (!quickViewInner) {
      console.warn(
        'Shop The Look: .quick-view-drawer_inner not found.'
      );
      return;
    }
    function openDrawer() {

      quickViewDrawer.classList.add('active');

      quickViewDrawer.removeAttribute('inert');

      document.documentElement.classList.add(
        'quick-view-open'
      );

      document.body.classList.add(
        'quick-view-open'
      );

    }
    function closeDrawer() {

      quickViewDrawer.classList.remove(
        'active'
      );

      window.setTimeout(function () {

        if (
          !quickViewDrawer.classList.contains(
            'active'
          )
        ) {

          quickViewDrawer.setAttribute(
            'inert',
            ''
          );

          // Clear injected content so leftover markup doesn't
          // linger in the DOM (avoids "broken HTML" warnings
          // when the theme editor re-renders other sections).
          quickViewInner.innerHTML = '';

        }

      }, 450);


      document.documentElement.classList.remove(
        'quick-view-open'
      );

      document.body.classList.remove(
        'quick-view-open'
      );

    }

    const closeButton =
      quickViewDrawer.querySelector(
        '.quick_view_close'
      );


    if (closeButton) {

      closeButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          closeDrawer();

        }
      );

    }

    function findProductSection(doc) {

      const selectors = [

        'section[id^="MainProduct-"]',
        'section[id*="main-product"]',
        'section[id*="product-template"]',
        'section.product',
        '.shopify-section:has(product-info)',
        '.shopify-section:has(product-form)'

      ];


      for (
        let i = 0;
        i < selectors.length;
        i++
      ) {

        try {

          const element =
            doc.querySelector(
              selectors[i]
            );

          if (element) {
            return element;
          }

        } catch (error) {
        
        }

      }

      const productForm =
        doc.querySelector(
          'product-form'
        );

      if (productForm) {

        const parent =
          productForm.closest(
            'section, .shopify-section, .product'
          );

        if (parent) {
          return parent;
        }

      }

      const form =
        doc.querySelector(
          'form[action*="/cart/add"]'
        );


      if (form) {

        const parent =
          form.closest(
            '.product-form-wrapper, .product__info-wrapper, .product-information, product-info, section, .shopify-section, .product'
          );

        if (parent) {
          return parent;
        }

      }


      return null;

    }

    function cleanProductContent(
      container
    ) {

      const removeSelectors = [
        'product-recommendations',
        '.product-recommendations',
        '.product__recommendations',
        '.related-products',
        '.product-related',
        '.related-products-section',
        'complementary-products',
        '.complementary-products',
        '.recently-viewed',
        '.recently-viewed-products',
        '.product-faq',
        '.product__faq',
        '.faq',
        '.faqs',
        '.faq-section',
        '.product-reviews',
        '.reviews',
        '#reviews',
        '.product-questions',
        '.breadcrumbs',
        '.breadcrumb',
        '.share-button',
        '.share-buttons',
        'pickup-availability',
        '.shopify-payment-button',
        '[data-product-recommendations]',
        '[data-related-products]',

        // Extra: structurally risky / not needed in the quick view
        'script[type="application/ld+json"]',
        'link',
        'meta',
        'style',
        'noscript'

      ];


      container
        .querySelectorAll(
          removeSelectors.join(',')
        )
        .forEach(function (element) {

          element.remove();

        });

      container
        .querySelectorAll(
          '.shopify-section'
        )
        .forEach(function (element) {

          if (
            element.querySelector(
              'product-form'
            ) ||
            element.querySelector(
              'form[action*="/cart/add"]'
            ) ||
            element.querySelector(
              'product-info'
            )
          ) {
            return;
          }

          element.remove();

        });


      return container;

    }

    async function loadQuickView(
      productUrl
    ) {

      if (!productUrl) return;

      quickViewInner.innerHTML = `
        <div class="stl-qv-loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      `;

      openDrawer();


      try {

        const response =
          await fetch(
            productUrl,
            {
              method: 'GET',

              headers: {
                'X-Requested-With':
                  'XMLHttpRequest',

                'Accept':
                  'text/html'
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            'Unable to load product.'
          );

        }


        const html =
          await response.text();

        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            html,
            'text/html'
          );

        const productSection =
          findProductSection(
            doc
          );


        if (!productSection) {

          throw new Error(
            'Main product section not found.'
          );

        }

        const clonedProduct =
          productSection.cloneNode(
            true
          );

        cleanProductContent(
          clonedProduct
        );

        let productContent =
          clonedProduct;

        const productInner =
          clonedProduct.querySelector(
            'product-info'
          );

        if (productInner) {

          productContent =
            productInner.cloneNode(
              true
            );

        }

        if (
          !productInner
        ) {

          const infoWrapper =
            clonedProduct.querySelector(
              '.product__info-wrapper, ' +
              '.product-information, ' +
              '.product-info, ' +
              '.product__info-container'
            );


          if (infoWrapper) {

            productContent =
              infoWrapper.cloneNode(
                true
              );

          }

        }

        cleanProductContent(
          productContent
        );

        quickViewInner.innerHTML = '';

        quickViewInner.appendChild(
          productContent
        );

        fixDuplicateIds(
          quickViewInner
        );

        executeScripts(
          quickViewInner
        );

        initializeQuickViewElements(
          quickViewInner
        );

        document.dispatchEvent(
          new CustomEvent(
            'quickview:loaded',
            {
              detail: {
                container:
                  quickViewInner,

                productUrl:
                  productUrl
              },

              bubbles: true
            }
          )
        );


      } catch (error) {

        console.error(
          'Shop The Look Quick View:',
          error
        );

        quickViewInner.innerHTML = `
          <div class="stl-qv-error">

            <p>
              Unable to load product.
            </p>

            <a href="${productUrl}">
              View Product
            </a>

          </div>
        `;

      }

    }

    function fixDuplicateIds(
      container
    ) {

      const elements =
        container.querySelectorAll(
          '[id]'
        );


      elements.forEach(function (
        element
      ) {

        const oldId =
          element.id;

        const existing =
          document.getElementById(
            oldId
          );


        if (
          existing &&
          existing !== element
        ) {

          element.id =
            'qv-' +
            oldId;

        }

      });

    }

    function executeScripts(
      container
    ) {

      const scripts =
        Array.from(
          container.querySelectorAll(
            'script'
          )
        );


      scripts.forEach(function (
        oldScript
      ) {

        const newScript =
          document.createElement(
            'script'
          );

        Array.from(
          oldScript.attributes
        ).forEach(function (
          attribute
        ) {

          newScript.setAttribute(
            attribute.name,
            attribute.value
          );

        });

        newScript.textContent =
          oldScript.textContent;


        oldScript.replaceWith(
          newScript
        );

      });

    }

    function initializeQuickViewElements(
      container
    ) {
      window.setTimeout(
        function () {

          container
            .querySelectorAll(
              'product-info'
            )
            .forEach(function (
              element
            ) {

              try {

                if (
                  typeof element.connectedCallback ===
                  'function'
                ) {

                }

              } catch (error) {}

            });

          container
            .querySelectorAll(
              'product-form'
            )
            .forEach(function (
              element
            ) {

              try {

                element.dispatchEvent(
                  new CustomEvent(
                    'quickview:initialize',
                    {
                      bubbles: true
                    }
                  )
                );

              } catch (error) {}

            });

          container
            .querySelectorAll(
              'variant-selects, ' +
              'variant-radios'
            )
            .forEach(function (
              element
            ) {

              try {

                element.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );

              } catch (error) {}

            });

          if (
            window.Shopify &&
            Shopify.PaymentButton &&
            typeof Shopify.PaymentButton.init ===
              'function'
          ) {

            try {

              Shopify.PaymentButton.init();

            } catch (error) {}

          }


        },
        50
      );

    }

    quickViewButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const productUrl =
              button.dataset.productUrl;


            if (!productUrl) {
              console.warn(
                'Quick View: product URL missing.'
              );
              return;
            }

            loadQuickView(
              productUrl
            );

          }
        );

      }
    );

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !== 'Escape'
        ) {
          return;
        }

        if (
          !quickViewDrawer.classList.contains(
            'active'
          )
        ) {
          return;
        }


        closeDrawer();

      }
    );

    quickViewDrawer.addEventListener(
      'click',
      function (event) {

        if (
          event.target.closest(
            '.quick_view_wrapper_in'
          )
        ) {
          return;
        }

        closeDrawer();

      }
    );

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initSTLQuickView,
      {
        once: true
      }
    );

  } else {

    initSTLQuickView();

  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.detail &&
        rawSectionId &&
        event.detail.sectionId === rawSectionId
      ) {

        const section =
          document.getElementById(
            sectionId
          );


        if (section) {

          section.dataset
            .quickViewInitialized =
            'false';

        }


        initSTLQuickView();

      }

    }
  );

})();